// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c142ee4f","239":"45956c04","345":"52c8732c","594":"af7c00bc","977":"8784d48f"}[chunkId] + ".chunk.js";
};